import { History, Location } from "history";
import { OrganizationState } from "go-security/services/organizations/types";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import { PosReportCardType } from "../services/types";

export const switchToPreviousPOSReport = async (
	reportId: string,
	history: History,
	organization: OrganizationState,
	location: Location
) => {
	const previousReportId = await apiOrganization.getPreviousPosReport(reportId);

	if (previousReportId) {
		let path = `/${organization.id}/sales/pos_reports/${previousReportId}`;
		const lastPathElement = getLastPartOfLocationPathname(location);

		if (lastPathElement) {
			path += `/${lastPathElement}`;
		}
		history.push(path);
	}
};

export const switchToNextPOSReport = async (
	reportId: string,
	history: History,
	organization: OrganizationState,
	location: Location
) => {
	const nextReportId = await apiOrganization.getNextPosReport(reportId);

	if (nextReportId) {
		let path = `/${organization.id}/sales/pos_reports/${nextReportId}`;
		const lastPathElement = getLastPartOfLocationPathname(location);

		if (lastPathElement) {
			path += `/${lastPathElement}`;
		}
		history.push(path);
	}
};

const getLastPartOfLocationPathname = (location: Location) => {
	const pathname = location.pathname;
	const pathnameParts = pathname.split("/");
	const lastElement = pathnameParts[pathnameParts.length - 1];
	const posReportPreviewTabs = Object.keys(PosReportCardType);

	if (lastElement && posReportPreviewTabs.includes(lastElement.toUpperCase())) {
		return lastElement;
	}

	return "";
};
